import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ShortResponseDto, UserAlertDto, UserAlertsRequestDto } from '../../dto';
import { BaseApiHandleOptions, BaseApiService } from './base-api.service';

@Injectable({
    providedIn: 'root',
})
export class NewsAutomationsUserAlertsApiService {
    private readonly url: string = 'service/contactcloud/newsAutomations/userAlerts';

    constructor(private readonly baseApiService: BaseApiService) {
    }

    getUserAlertsList(params?: UserAlertsRequestDto): Observable<UserAlertDto[]> {
        return this.baseApiService.get<UserAlertDto[]>(`${this.url}/list`, {
            params: (params as HttpParams),
            showError: true,
        });
    }

    getUserAlertsCompanyEnableList(params?: UserAlertsRequestDto): Observable<UserAlertDto[]> {
        return this.baseApiService.get<UserAlertDto[]>(`${this.url}/companyEnableList`, {
            params: (params as HttpParams),
            showError: true,
        });
    }

    saveUserAlerts(body: UserAlertDto, options?: BaseApiHandleOptions): Observable<ShortResponseDto<string>> {
        return this.baseApiService.post<ShortResponseDto<string>>(`${this.url}/save`, body, options);
    }

    deleteUserAlerts(alert_ids: string[]): Observable<ShortResponseDto<string>> {
        return this.baseApiService.post<ShortResponseDto<string>>(`${this.url}/delete`, { alert_ids });
    }

    createNewsAutomations(body: UserAlertDto, showError: boolean = true, showSuccess: boolean = true): Observable<ShortResponseDto<string>> {
      return this.baseApiService.post('service/contactcloud/news/automations/save', body, { showError, showSuccess });
    }

    updateNewsAutomations(body: UserAlertDto, showError: boolean = true, showSuccess: boolean = true): Observable<ShortResponseDto<string>> {
      return this.baseApiService.put(`service/contactcloud/news/automations/update/${body.alert_id}`, body, { showError, showSuccess });
    }
}
